import { render, staticRenderFns } from "./TabReceiptDetails.vue?vue&type=template&id=bdc2ce1e&scoped=true"
import script from "./TabReceiptDetails.vue?vue&type=script&lang=js"
export * from "./TabReceiptDetails.vue?vue&type=script&lang=js"
import style0 from "./TabReceiptDetails.vue?vue&type=style&index=0&id=bdc2ce1e&prod&scoped=true&lang=css"
import style1 from "./TabReceiptDetails.vue?vue&type=style&index=1&id=bdc2ce1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc2ce1e",
  null
  
)

export default component.exports